import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getCardUid = (state: StateScheme) => {
    return state.fastPaymentCards.cardUid
}
